<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="12">
                <v-card width="100%">
                    <v-card-title class="d-block py-2 text-center font-weight-bold primary secondary--text" style="word-break: normal">
                        CONFIGURAR NOTIFICACIONES
                    </v-card-title>
                    <v-btn bottom color="secondary primary--text" depressed fab absolute right small @click="refresh">
                        <v-icon>mdi-sync</v-icon>
                    </v-btn>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
                <v-card>
                    <v-progress-linear indeterminate fixed v-if="loading" style="top:0"/>
                    <v-form ref="form" v-model="valid" @submit.prevent="submit" lazy-validation>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="form.enabled"
                                        label="Activar notificaciones"
                                        color="primary"
                                        :disabled="loading"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.app_id"
                                        label="Clave publica de OneSignal"
                                        prepend-icon="mdi-bell-badge"
                                        :rules="[rules.req('app_id')]"
                                        :error-messages="errors.app_id"
                                        :disabled="loading"
                                        @input="clearErrors('app_id')"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.rest_api_key"
                                        :label="settings.rest_api_key_configured ? 'Clave privada configurada' : 'Clave privada de OneSignal'"
                                        prepend-icon="mdi-shield-key"
                                        :append-icon="showRestKey ? 'mdi-eye-off' : 'mdi-eye'"
                                        :type="showRestKey ? 'text' : 'password'"
                                        :placeholder="settings.rest_api_key_configured ? 'Dejar vacio para conservar' : ''"
                                        :disabled="loading"
                                        :error-messages="errors.rest_api_key"
                                        @click:append="showRestKey = !showRestKey"
                                        @input="clearErrors('rest_api_key')"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit" color="success" :loading="loading" :disabled="loading || !valid">
                                <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Guardar
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
            <v-col cols="12" md="10" lg="8">
                <v-card>
                    <v-progress-linear indeterminate absolute v-if="operationalLoading"/>
                    <v-form ref="operationalForm" v-model="operationalValid" @submit.prevent="submitOperational" lazy-validation>
                        <v-card-title>Avisos operativos por correo</v-card-title>
                        <v-card-subtitle>
                            Recibe avisos de clientes por verificar, nuevas solicitudes y pendientes demorados.
                        </v-card-subtitle>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-switch
                                        v-model="operational.enabled"
                                        label="Activar avisos operativos por correo"
                                        color="primary"
                                        :disabled="operationalLoading"/>
                                </v-col>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model.trim="operational.email"
                                        label="Correo que recibira los avisos"
                                        prepend-icon="mdi-email-alert"
                                        type="email"
                                        :rules="operational.enabled ? [rules.req('email'), rules.mail('email')] : []"
                                        :error-messages="operationalErrors.email"
                                        :disabled="operationalLoading"
                                        @input="clearOperationalError('email')"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="operational.customer_verification"
                                        label="Clientes por verificar"
                                        color="primary"
                                        :disabled="operationalLoading || !operational.enabled"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="operational.shipment_created"
                                        label="Nuevas solicitudes de envio"
                                        color="primary"
                                        :disabled="operationalLoading || !operational.enabled"/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-switch
                                        v-model="operational.pending_reminders"
                                        label="Pendientes demorados"
                                        color="primary"
                                        :disabled="operationalLoading || !operational.enabled"/>
                                </v-col>
                                <v-col cols="12" md="6" v-if="operational.pending_reminders">
                                    <v-text-field
                                        v-model.number="operational.pending_minutes"
                                        label="Avisar despues de (minutos)"
                                        prepend-icon="mdi-timer-alert"
                                        type="number"
                                        min="60"
                                        max="1440"
                                        hint="El minimo es una hora. Cada pendiente genera un solo recordatorio."
                                        persistent-hint
                                        :disabled="operationalLoading || !operational.enabled"
                                        :error-messages="operationalErrors.pending_minutes"
                                        @input="clearOperationalError('pending_minutes')"/>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-divider/>
                        <v-card-actions>
                            <v-spacer/>
                            <v-btn type="submit" color="success" :loading="operationalLoading" :disabled="operationalLoading || !operationalValid">
                                <v-icon>mdi-check-circle</v-icon>&nbsp;&nbsp;Guardar avisos
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';
import Form from "../../../helpers/form";

export default {
    name: "configNotifications",
    mixins: [ Form ],
    props: ['user'],
    data: () => ({
        loading: true,
        valid: true,
        showRestKey: false,
        labels: {
            email: 'correo'
        },
        settings: {
            rest_api_key_configured: false
        },
        operationalLoading: true,
        operationalValid: true,
        operationalErrors: {},
        operational: {
            enabled: true,
            email: '',
            customer_verification: true,
            shipment_created: true,
            pending_reminders: true,
            pending_minutes: 60
        },
        form: {
            enabled: true,
            app_id: '',
            rest_api_key: ''
        }
    }),
    created() {
        this.getData();
        this.getOperational();
    },
    methods: {
        refresh() {
            this.getData();
            this.getOperational();
        },
        getData() {
            this.loading = true;
            axios.get('/api/settings/notifications/onesignal').then(res => {
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar notificaciones.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        applySettings(settings) {
            this.settings = settings;
            this.form.enabled = settings.enabled !== false;
            this.form.app_id = settings.app_id || '';
            this.form.rest_api_key = '';
        },
        getOperational() {
            this.operationalLoading = true;
            axios.get('/api/settings/notifications/operational-email').then(res => {
                this.operational = Object.assign({}, this.operational, res.data.settings || {});
            }).catch(err => {
                this.$toast.error(this.errorMessage(err, 'No fue posible cargar los avisos por correo.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.operationalLoading = false;
            });
        },
        submitOperational() {
            if (!this.$refs.operationalForm.validate()) return;

            this.operationalLoading = true;
            this.operationalErrors = {};
            axios.post('/api/settings/notifications/operational-email', this.operational).then(res => {
                this.operational = Object.assign({}, this.operational, res.data.settings || {});
                this.$toast.success(res.data.status, {icon: 'mdi-email-check'});
            }).catch(err => {
                this.operationalErrors = err.response && err.response.data && err.response.data.errors
                    ? err.response.data.errors
                    : {};
                this.$toast.error(this.errorMessage(err, 'No fue posible guardar los avisos por correo.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.operationalLoading = false;
            });
        },
        clearOperationalError(field) {
            if (this.operationalErrors[field]) {
                this.$delete(this.operationalErrors, field);
            }
        },
        submit() {
            if (!this.$refs.form.validate()) return;

            this.loading = true;
            axios.post('/api/settings/notifications/onesignal', this.form).then(res => {
                this.$toast.success(res.data.status, {icon: 'mdi-check-circle'});
                this.applySettings(res.data.settings || {});
            }).catch(err => {
                this.handleErrors(err.response && err.response.data ? err.response.data.errors : {});
                this.$toast.error(this.errorMessage(err, 'No fue posible guardar notificaciones.'), {icon: 'mdi-alert-circle'});
            }).then(() => {
                this.loading = false;
            });
        },
        errorMessage(err, fallback) {
            if (err.response && err.response.data && err.response.data.status) {
                return err.response.data.status;
            }

            return fallback;
        }
    }
}
</script>

<style scoped>

</style>
